The value of `Candidate.documentId` for the requested object.
